import axios from 'axios';
import { API_URL, RAZORPAY_KEY } from '../utils/constants';

// GST and Net Handling charges (matching mobile app)
export const GST_CHARGE = 18;
export const NET_HANDELING = 5;

export const paymentAPI = {
  // Get Coupons
  getCoupons: async (courseId, couponCode) => {
    const response = await axios.get(`${API_URL}/getCoupons/${courseId}/${couponCode}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Check Discount
  checkDiscount: async (userId, courseId) => {
    const response = await axios.get(`${API_URL}/checkdiscount/${userId}/${courseId}`);
    return response.data;
  },

  // Razorpay Payment Verification - matching mobile app
  verifyPayment: async (paymentData) => {
    const formData = new FormData();
    formData.append('name', paymentData.name);
    formData.append('email', paymentData.email);
    formData.append('mobile', paymentData.mobile);
    formData.append('uid', paymentData.uid);
    formData.append('coursePrice', paymentData.coursePrice);
    formData.append('amount', paymentData.amount);
    formData.append('purpose', paymentData.purpose);
    formData.append('courseid', paymentData.courseid);
    formData.append('pay_status', 'Credit');
    formData.append('couponCode', paymentData.couponCode || '');
    formData.append('discount', paymentData.discount || '0');
    formData.append('razorpay_payment_id', paymentData.razorpay_payment_id);

    const response = await axios.post(`${API_URL}/razorpay`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Initialize Razorpay Payment
  initializeRazorpay: (courseInfo, purchaseVal, discountedPrice, discount, couponCode, onSuccess, onFailure) => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onerror = () => {
        onFailure('Failed to load Razorpay SDK');
        resolve(false);
      };
      script.onload = () => {
        const price = discountedPrice || courseInfo.price;
        
        const options = {
          key: RAZORPAY_KEY,
          amount: price * 100, // Amount in paise
          currency: 'INR',
          name: courseInfo.sub_name || courseInfo.course_name,
          description: courseInfo.description || 'Course Purchase',
          image: 'https://www.careerfoundation.org.in/assets/images/logo/logo.png',
          handler: async function (response) {
            try {
              // Prepare payment data
              const paymentData = {
                name: purchaseVal.name,
                email: purchaseVal.email,
                mobile: purchaseVal.mobile,
                uid: purchaseVal.uid,
                coursePrice: courseInfo.price,
                amount: price,
                purpose: courseInfo.sub_name || courseInfo.course_name,
                courseid: courseInfo.id,
                couponCode: couponCode || '',
                discount: discount || 0,
                razorpay_payment_id: response.razorpay_payment_id,
              };

              // Verify payment with backend
              const result = await paymentAPI.verifyPayment(paymentData);
              onSuccess(result, response.razorpay_payment_id);
              resolve(true);
            } catch (error) {
              onFailure('Payment verification failed');
              resolve(false);
            }
          },
          prefill: {
            name: purchaseVal.name,
            email: purchaseVal.email,
            contact: purchaseVal.mobile,
          },
          theme: {
            color: '#2196F3',
          },
          modal: {
            ondismiss: function() {
              onFailure('Payment cancelled by user');
              resolve(false);
            }
          }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.open();
      };
      document.body.appendChild(script);
    });
  },
};

